import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { BackupState } from '../../reducers/backups';

export const getChatgptActionsSelector = createSelector((state: DefaultRootState) => state.backups, ({chatgpt}: BackupState) => chatgpt.actions);
export const getChatgptActionsTotalSelector = createSelector((state: DefaultRootState) => state.backups, ({chatgpt}: BackupState) => chatgpt.totalActions);
export const isChatgptActionsLoadingSelector = createSelector((state: DefaultRootState) => state.backups, ({chatgpt}: BackupState) => chatgpt.loading);
export const getChatgptCanRestore = createSelector((state: DefaultRootState) => state.backups, ({chatgpt}: BackupState) => chatgpt.canRestore);
